import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  checkout?: boolean;
}
export function Button({
  children,
  className = '',
  onClick,
  checkout = false
}: ButtonProps) {
  const checkoutUrl = 'https://checkout.academiaonlinepro.shop/cart/47110701416633:1';
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    if (checkout) {
      window.open(checkoutUrl, '_blank');
      return;
    }
    // Default: scroll to pricing section
    const el = document.getElementById('precio-lanzamiento');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <button onClick={handleClick} className={`bg-[#C6F432] hover:bg-[#B8E821] text-[#0A1628] font-black uppercase tracking-wide py-4 px-8 rounded-xl shadow-[0_0_20px_rgba(198,244,50,0.4)] hover:shadow-[0_0_30px_rgba(198,244,50,0.6)] transition-all duration-300 transform hover:-translate-y-1 ${className}`} data-id="element-42">
      {children}
    </button>;
}